const initDisplayToggle = () => {
	const frontviewItems = document.querySelectorAll(".frontview");
	const backviewItems = document.querySelectorAll(".backview");
	const backviewToggle = document.querySelector("#backview-toggle");
	const frontviewToggle = document.querySelector("#frontview-toggle");
	backviewToggle.addEventListener("click", (e) => {
		for (let item of frontviewItems) {
			item.classList.add("hidden");
		}
		for (let item of backviewItems) {
			item.classList.remove("hidden");
		}
	});
	frontviewToggle.addEventListener("click", (e) => {
		for (let item of backviewItems) {
			item.classList.add("hidden");
		}
		for (let item of frontviewItems) {
			item.classList.remove("hidden");
		}
	});
};
export { initDisplayToggle };
